import { render, staticRenderFns } from "./instagram.vue?vue&type=template&id=4088717a&"
import script from "./instagram.vue?vue&type=script&lang=js&"
export * from "./instagram.vue?vue&type=script&lang=js&"
import style0 from "./instagram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/nickyeconomou.com/public/site/nickyeconomou/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4088717a')) {
      api.createRecord('4088717a', component.options)
    } else {
      api.reload('4088717a', component.options)
    }
    module.hot.accept("./instagram.vue?vue&type=template&id=4088717a&", function () {
      api.rerender('4088717a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/instagram.vue"
export default component.exports